import {AfterViewInit, Component} from '@angular/core';
import {CommonModule} from "@angular/common";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../src/environments/environment";
import {catchError} from "rxjs/operators";
import {Router} from "@angular/router";

@Component({
    selector: 'app-error502',
    template: `
    <div class="container container_bg-503">
      <header class="header">
        <div class="header__title">
          INSPARK PLATFORM
        </div>
      </header>
      <section class="section section_main">
        <img src="assets/static/img/content/svg/update.svg" class="section__bg-503" alt="Технические работы, обновление системы">
        <h1 class="section__title">Проводим техническое обслуживание</h1>
        <p>Мы проводим технические работы по обновлению приложения и сервисов. Очень скоро
          приложение INSPARK снова станет доступно. Попробуйте зайти через 20 минут.
          Мы приносим извинения за доставленные неудобства. Спасибо за понимание!</p>
      </section>
      <footer class="footer">
        <div class="footer__title">Служба поддержки пользователей</div>
        <a href="tel:+74957800896" class="footer__link">+7 (495) 780-08-95</a>
        <a href="mailto:sd@inspark.ru" class="footer__link">sd&#64;inspark.ru</a>
      </footer>
    </div>
  `,
    styles: [`
    @font-face {
      font-family: 'Open Sans';
      font-weight: bold;
      font-style: normal;
    }

    * {
      margin: 0;
      padding: 0;
      outline: 0;
    }

    html {
      min-width: 320px;
      background: #30333C;
      font-size: 14px;
      line-height: 1.375;
      font-family: "Open Sans", "Helvetica Neue", sans-serif;
    }

    body {
      color: #ffffff;
    }

    a {
      /*color: #78f4ff;*/
      text-decoration: none;
    }

    p {
      font-size: 16px;
      margin-bottom: 16px;
    }

    .container {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
    }

    @media (min-width: 576px) {
      .container {
        max-width: 540px;
      }
    }

    @media (min-width: 768px) {
      .container {
        max-width: 720px;
      }
    }

    @media (min-width: 992px) {
      .container {
        max-width: 960px;
      }
    }

    @media (min-width: 1200px) {
      .container {
        max-width: 1140px;
      }
    }

    .header {
      padding: 24px 16px;
      margin-top: 32px;
    }

    .header__title {
      font-size: 24px;
      font-weight: bold;
    }

    @media (min-width: 768px) {
      .header__title {
        font-size: 28px;
      }
    }

    .section {
      position: relative;
      padding: 0 16px;
    }

    .section_main {
      margin-top: 24px;
    }

    @media (min-width: 768px) {
      .section_main {
        margin-top: 160px;
      }
    }

    .section__bg-503 {
      position: absolute;
      top: -72px;
      left: -214px;
      width: 502px;
    }

    @media (min-width: 768px) {
      .section__bg-503 {
        top: -210px;
        left: -273px;
      }
    }

    @media (min-width: 1440px) {
      .section__bg-503 {
        left: -440px;
      }
    }

    .section__title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    @media (min-width: 768px) {
      .section__title {
        font-size: 28px;
      }
    }

    .footer {
      margin-top: 32px;
      padding: 0 16px;
    }

    .footer__title {
      margin-bottom: 8px;
    }

    .footer__link {
      display: block;
    }

  `],
    imports: [CommonModule,
        // TODO: `HttpClient` should not be imported into a component directly.
        // Please refactor the code to add `provideHttpClient()` call to the provider list in the
        // application bootstrap logic and remove the `HttpClient` import from this component.
        HttpClient]
})
export class Error502Component implements AfterViewInit {
  constructor(private http: HttpClient,private router: Router) {
  }
  ngAfterViewInit() {
    this.http.get(environment.backEndUrlPrefix + '/' + '/auth/userstatus').subscribe({
      next: (response) => {
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
}
